export const option_enabled = [
  { label: "啟用", value: 1 },
  { label: "停用", value: 0 },
];

export const option_account_type = [
  { label: "對照組", value: 1 },
  { label: "實驗組", value: 2 },
];

export const option_question = {
  type1: [
    { key: "q1", title: "充滿活力" },
    { key: "q2", title: "有非常多熱情" },
    { key: "q3", title: "喜歡外出、好社交的" },
    { key: "q4", title: "樂於助人且無私的" },
    { key: "q5", title: "有寬容本質" },
    { key: "q6", title: "幾乎對所有人體貼且仁慈的" },
    { key: "q7", title: "可信賴的工作者" },
    { key: "q8", title: "會堅持到工作完成" },
    { key: "q9", title: "做事有效率的" },
    { key: "q10", title: "擔心很多的" },
    { key: "q11", title: "情緒不穩定的" },
    { key: "q12", title: "容易感到緊張的" },
    { key: "q13", title: "具有生動想像力" },
    { key: "q14", title: "有創造力的" },
    { key: "q15", title: "重視藝術及美學經驗" },
  ],
  type2: [
    { key: "q1", title: "我的工作或生涯能讓我有機會回饋社會。" },
    { key: "q2", title: "我的工作或生涯能讓我樂在其中。" },
    { key: "q3", title: "我的生涯是朝向自己喜歡做的事情來選擇或規劃。" },
    { key: "q4", title: "我的工作或生涯對改變社會現狀有所幫助。" },
    { key: "q5", title: "透過工作或生涯，讓我能達成來到這個世界的使命。" },
    { key: "q6", title: "我的工作或生涯可以對他人產生正面影響。" },
    { key: "q7", title: "我的工作或生涯就是我的熱情所在。" },
    { key: "q8", title: "我的工作或生涯能實踐自己的理想。" },
    { key: "q9", title: "我的工作或生涯能夠為社會帶來正向的影響。" },
    { key: "q10", title: "我的工作或生涯可以發揮我的潛能。" },
    { key: "q11", title: "我的工作或生涯讓我能朝自己所要的方向發展。" },
    {
      key: "q12",
      title:
        "我知道要從事的工作或生涯方向，是因為領略到超越個人之外的呼喚力量。",
    },
    { key: "q13", title: "我的工作或生涯讓我能感受到存在的價值。" },
    {
      key: "q14",
      title: "我之所以從事目前的行業，是因為我相信這就是我的使命所在。",
    },
    { key: "q15", title: "我的工作或生涯可以發揮我的特質。" },
    { key: "q16", title: "我將我的生涯視為達成我生活目標的途徑。" },
    { key: "q17", title: "我的工作或生涯可以直接的幫助到別人。" },
    { key: "q18", title: "我生涯中最重要的一部分，就是能夠幫助到別人。" },
    { key: "q19", title: "我的工作或生涯能完成我這一生的使命。" },
    { key: "q20", title: "我的工作或生涯能做我覺得有意義的事。" },
  ],
  type3: [
    { key: "q1", title: "透過參與活動了解我的能力和興趣" },
    { key: "q2", title: "持續參與我所選擇的活動和新經歷" },
    { key: "q3", title: "參與對我的職業和生活發展有幫助的活動" },
    { key: "q4", title: "理解職業和生活發展規劃的過程和步驟" },
    {
      key: "q5",
      title: "根據我的屬性（例如興趣）而考慮不同的職業和生活發展選擇途徑",
    },
    { key: "q6", title: "保持對實現職業和生活發展的期望和對目標抱有希望感" },
    {
      key: "q7",
      title: "透過日常生活的自我觀察來確認我的興趣、能力和價值觀",
    },
    {
      key: "q8",
      title: "根據個人屬性（例如興趣、能力）選擇職業和生活發展的途徑與方向",
    },
    { key: "q9", title: "陳述能夠達成職業和生活發展目標的學習和培訓方法" },
    { key: "q10", title: "根據個人和環境因素比較不同的職業和生活發展途徑" },
    { key: "q11", title: "根據個人和環境因素選擇最適合的職業和生活發展途徑" },
    {
      key: "q12",
      title: "辨識在追求職業和生活發展目標時所遇到的個人限制和社會障礙",
    },
    {
      key: "q13",
      title:
        "了解做出良好職業和生活發展決策的必要步驟，並理解自己決策方法的優勢和侷限",
    },
    {
      key: "q14",
      title:
        "運用自我管理技能（例如人際技能、團隊合作、時間管理、可靠性、誠實以及解決問題能力）來促進在職場的表現和發展",
    },
    {
      key: "q15",
      title: "取得相關的支持和指導，以解決與職業和生活發展相關的困難",
    },
    {
      key: "q16",
      title: "繼續發展我的能力、興趣、價值觀，並深化對工作世界的理解",
    },
    {
      key: "q17",
      title: "能應對未來職業和生活發展的過渡和變化，以及相關的壓力",
    },
  ],
};

export const option_level = {
  type1: [
    { label: "非常不精確", value: 1 },
    { label: "有些不精確", value: 2 },
    { label: "普通", value: 3 },
    { label: "有些精確", value: 4 },
    { label: "非常精確", value: 5 },
  ],
  type2: [
    { label: "完全符合", value: 4 },
    { label: "大部分符合", value: 3 },
    { label: "部分符合", value: 2 },
    { label: "完全不符合", value: 1 },
  ],
  type3: [
    { label: "極度沒自信", value: 1 },
    { label: "有些沒自信", value: 2 },
    { label: "普通", value: 3 },
    { label: "有些自信", value: 4 },
    { label: "極度有自信", value: 5 },
  ],
};

export const option_group = {
  type1: [
    { name: "外向性", key: "type1" },
    { name: "友善性", key: "type2" },
    { name: "嚴謹性", key: "type3" },
    { name: "神經質", key: "type4" },
    { name: "開放性", key: "type5" },
  ],
  type2: [
    { name: "興趣熱情", key: "type1" },
    { name: "存在意義", key: "type2" },
    { name: "利他助人", key: "type3" },
    { name: "超越奉獻", key: "type4" },
  ],
  type3: [
    { name: "生涯活動參與", key: "type1" },
    { name: "自我了解", key: "type2" },
    { name: "生涯軌跡探索", key: "type3" },
    { name: "生涯規劃管理", key: "type4" },
  ],
};

export const option_score = {
  type1: 5,
  type2: 4,
  type3: 5,
};

export const option_q_title = {
  type1: "BFI15五大人格量表",
  type2: "成人生涯召喚量表",
  type3: "青年生涯發展能力量表",
};
